export const routes = [
  {
    path: "/inscricao/auth/login",
    component: () => import("./components/Login"),
    name: "auth.login",
    meta: {
      requiresNoAuth: true,
    },
  },
  {
    path: "/inscricao/user/trocar-senha",
    component: () => import("./components/RecoverPassword"),
    name: "auth.trocarSenha",
    meta: {
      requiresAuth: true,
    },
  },
];
